export const apiInvitedUsers = async ({commit, dispatch, state}, {countries, institutions, date_from, date_to} ) => {
 	const invitations =  await axios.get("/reporting/invitations", {
    params: { 
      date_from: date_from, 
      date_to: date_to,
      countries: countries,
      institutions: institutions
    }
  }).then((v) => v.data);
	
	commit('setInvitedUsers', invitations)
}

export const apiPatientsFunnel = async ({commit, dispatch, state}, {countries, institutions} ) => {
 	const patients =  await axios.get("/reporting/patients", {
  	params: { 
  		countries: countries,
  		institutions: institutions
  	}
  }).then((v) => v.data);

	commit('setPatients', patients)
}

export const apiPatientsFunnelEvents = async ({commit, dispatch, state}, {countries, institutions, date_from, date_to} ) => {
  const patientsEvents =  await axios.get("/reporting/funnelEvents", {
   params: { 
    date_from: date_from, 
    date_to: date_to,
    countries: countries,
    institutions: institutions
   }
 }).then((v) => v.data);

 commit('setPatientsEvents', patientsEvents)
}

export const apiPatientValues = async ({commit, dispatch, state}, {countries, institutions} ) => {
  const values =  await axios.get("/reporting/patient/values", {
    params: { 
      countries: countries,
      institutions: institutions
    }
  }).then((v) => v.data);

  commit('setPatientValues', values)
}

export const apiDoctors = async ({commit, dispatch, state}, {countries, institutions, date_from, date_to} ) => {
  const doctors =  await axios.get("/reporting/doctors", {
    params: { 
      countries: countries,
      institutions: institutions,
      date_from: date_from, 
      date_to: date_to,
    }
  }).then((v) => v.data);

  commit('setDoctors', doctors)
}

export const filterData = async ({commit, dispatch, state}, {countries, institutions, date_from, date_to} ) => {
  dispatch('apiPatientsFunnel', { institutions: institutions, countries: countries })
  dispatch('apiPatientsFunnelEvents', { institutions: institutions, countries: countries, date_from: date_from, date_to: date_to })
  dispatch('apiPatientValues', { institutions: institutions, countries: countries })
  dispatch('apiDoctors', { institutions: institutions, countries: countries, date_from: date_from, date_to: date_to })
  dispatch('apiInvitedUsers', { institutions: institutions, countries: countries, date_from: date_from, date_to: date_to })
}